namespace GeniuzPOS.Points {
    export interface PrPointCampaignRow {
        Id?: number;
        MemberType?: string;
        DowId?: number;
        DowName?: string;
        PointRedeemOneBaht?: number;
        OnePointbyAmt?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PrPointCampaignRow {
        export const idProperty = 'Id';
        export const nameProperty = 'DowName';
        export const localTextPrefix = 'Points.PrPointCampaign';
        export const lookupKey = 'Points.PrPointCampaign';

        export function getLookup(): Q.Lookup<PrPointCampaignRow> {
            return Q.getLookup<PrPointCampaignRow>('Points.PrPointCampaign');
        }
        export const deletePermission = '3Member:Points:เงื่อนไขการสะสมแต้ม:Delete';
        export const insertPermission = '3Member:Points:เงื่อนไขการสะสมแต้ม:Modify';
        export const readPermission = '3Member:Points:เงื่อนไขการสะสมแต้ม:View';
        export const updatePermission = '3Member:Points:เงื่อนไขการสะสมแต้ม:Modify';

        export declare const enum Fields {
            Id = "Id",
            MemberType = "MemberType",
            DowId = "DowId",
            DowName = "DowName",
            PointRedeemOneBaht = "PointRedeemOneBaht",
            OnePointbyAmt = "OnePointbyAmt",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
